import { Button, HStack, Select, Text } from "@chakra-ui/react";

type Props = {
  page: number;
  pageSize: number;
  total: number;
  onChange: (page: number) => void;
  onPageSizeChange?: (size: number) => void;
  pageSizeOptions?: number[];
};

const DEFAULT_PAGE_SIZE_OPTIONS = [20, 40, 100, 200];

export default function Pagination({
  page,
  pageSize,
  total,
  onChange,
  onPageSizeChange,
  pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS,
}: Props) {
  const lastPage = Math.max(1, Math.ceil(total / pageSize));
  const start = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);
  return (
    <HStack spacing={3} mt={4}>
      <Button size="sm" onClick={() => onChange(page - 1)} isDisabled={page <= 1}>
        Previous
      </Button>
      <Text fontSize="sm" color="gray.600">
        {start}–{end} of {total} (page {page} / {lastPage})
      </Text>
      <Button size="sm" onClick={() => onChange(page + 1)} isDisabled={page >= lastPage}>
        Next
      </Button>
      {onPageSizeChange && (
        <HStack spacing={1}>
          <Text fontSize="sm" color="gray.600">
            Per page
          </Text>
          <Select
            size="sm"
            maxW="90px"
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
          >
            {pageSizeOptions.map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </Select>
        </HStack>
      )}
    </HStack>
  );
}
